import BaseAPI from 'api/api'
import { FindAllInterface } from 'api/api-interface'
import { FindDoctorFeeProps } from 'api/dentists/treatment.api'
import { getBranch } from 'utils/app.utils'

const path = 'approval'

export type ApprovalProps = {
    approvalName: string
    hasCancelReciept: "PERMISS" | "UNPERMISS"
    hasChangeCost: "PERMISS" | "UNPERMISS"
    hasOverduePayment: "PERMISS" | "UNPERMISS"
    approveChanelEmail: "0" | "1",
    approveChanelLine: "0" | "1",
    status: "ACTIVE" | "INACTIVE"
    branchId: number
    approvalUsers: { userId: number }[]
    branchConnect?: number[]
}

export type ApprovalCancelReceipt = {
    requestReason?: string
    requestUserName?: string
    requestUserId?: number
    approveRemark?: string
    refId?: number
    branchId?: number
    status: ApprovalStatus
    managerSignature?: string
}

export type ApprovalLinkProps = {
    approveRemark: string
    status: ApprovalStatus
    approveToken: string
}

export type ApprovalOverdueProps = {
    overdueTotal: number,
    overdueDateStart: string,
    overdueDate: string,
    patientSignature: string,
    doctorId: number,
    doctorSignature: string,
    doctorName: string,
    financeName?: string,
    financeSignature?: string
}

export enum ApprovalStatus {
    APPROVED = "APPROVED",
    PENDING = "PENDING",
    REJECT = "REJECT",
    CANCEL = "CANCEL",
    // WAITING_FINANCE = "WAITING_FINANCE"
}

export type FinanceAcknowledgeProps = {
    financeSignature: string
}

export default class ApprovalApi extends BaseAPI {

    static findApprovalAll(props: FindAllInterface): Promise<any> {
        return this.api.get(`${path}`, { params: { ...props } })
    }

    static createApproval(payload: ApprovalProps): Promise<any> {
        return this.api.post(`${path}`, { ...payload })
    }

    static updateApproval(id: number, payload: ApprovalProps): Promise<any> {
        return this.api.patch(`${path}/${id}`, { ...payload })
    }
    static updateStatusApproval(id: number, status: string): Promise<any> {
        return this.api.patch(`${path}/${id}/status`, { status: status })
    }

    static deteleApproval(id: number): Promise<any> {
        return this.api.patch(`${path}/${id}/status`, { status: 'DELETED' })
    }

    static findById(id: number): Promise<any> {
        return this.api.get(`${path}/${id}`)
    }

    static findUsersApproval(): Promise<any> {
        return this.api.get(`${path}/users/${getBranch()}`)
    }

    static findApprovalListAll(props: FindAllInterface): Promise<any> {
        return this.api.get(`${path}/items`, { params: { ...props } })
    }

    static checkApprovePermiss(): Promise<any> {
        return this.api.get(`${path}/approve-permiss/${getBranch()}`)
    }

    static approvalCancelReceipt(id: number, payload: ApprovalCancelReceipt): Promise<any> {
        return this.api.patch(`${path}/approve/${id}`, { ...payload })
    }

    static findApprovalPayment(id: string): Promise<any> {

        return this.api.get(`${path}/payment/${id}`)
    }

    static findApprovalChangeCost(id: string): Promise<any> {
        return this.api.get(`${path}/change-cost/${id}`)
    }

    static findApprovalChangeCostWithoutToken(id: string): Promise<any> {
        return this.publicApi.get(`${path}/change-cost/${id}`)
    }

    static findApprovalItemById(approvalItemId: number): Promise<any> {
        return this.api.get(`${path}/items/${approvalItemId}`)
    }

    static findApprovalOperativeById(params: FindDoctorFeeProps): Promise<any> {
        return this.api.get(`${path}/operative-df`, { params: { ...params } })
    }

    static approvalLink(id: number, payload: ApprovalLinkProps): Promise<any> {
        return this.api.patch(`${path}/approve-link/${id}`, { ...payload },)
    }

    static approvalLinkOutToken(id: string, payload: ApprovalLinkProps): Promise<any> {
        return this.publicApi.patch(`${path}/approve-link/${id}`, { ...payload },)
    }

    static findApprovalOverduePayment(id: string): Promise<any> {
        return this.api.get(`${path}/item-overdue/${id}`)
    }

    static findApprovalOverduePaymentOutToken(id: string, token: string): Promise<any> {
        return this.publicApi.get(`${path}/overdue/${id}`, { params: { token } })
    }

    static createApprovalOverdue(patientCaseId: number, payload: ApprovalOverdueProps): Promise<any> {
        return this.api.post(`${path}/overdue-bill/${patientCaseId}`, { ...payload })
    }

    static findApprovalBranch(): Promise<any> {
        return this.api.get(`${path}/approve-branch`)
    }

    /**
     * ดึงรายการที่รอพนักงานการเงินเซ็นรับทราบ
     */
    static findWaitingFinanceItems(branchId?: number, page = 1, pageLimit = 10): Promise<any> {
        return this.api.get(`${path}/waiting-finance`, { params: { branchId, page, pageLimit } })
    }

    /**
     * พนักงานการเงินเซ็นรับทราบคำขอค้างชำระ
     */
    static financeAcknowledge(approvalItemId: number, payload: FinanceAcknowledgeProps): Promise<any> {
        return this.api.patch(`${path}/finance-acknowledge/${approvalItemId}`, { ...payload })
    }

}

